import { ReactNode } from 'react';

import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';

import { ddmm } from '~/src/helpers/date';

import { Info, Text, Wrapper } from './styled';

interface IProps {
    autoPayStatus?: boolean,
    comingPayDay?: string,
    paySum?: number,
    children?: ReactNode | null,
}

const AutoPayInfo = ({ autoPayStatus, comingPayDay, paySum, children }: IProps): JSX.Element => {
    const localePayDay = comingPayDay
        ? ddmm(new Date(comingPayDay).toLocaleString('ru-RU'))
        : '';

    return (
        <Wrapper>
            {autoPayStatus && !!comingPayDay && <Text data-test='autopay-status'>Автоплатёж подключен,</Text>}
            <Info>
                <Text data-test='autopay-info'>
                    {localePayDay
                        ? `${localePayDay} будет списано ${paySum} ${RubleSymbol}.`
                        : `Автоплатёж ${autoPayStatus ? '' : 'не '}подключен. `
                    }
                </Text>
                {children}
            </Info>
        </Wrapper>
    );
};

export default AutoPayInfo;
